import { useCallback, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface DmcaInput {
  reporter_name: string;
  reporter_email: string;
  reporter_address?: string;
  copyright_owner?: string;
  work_description: string;
  infringing_url: string;
  good_faith_statement: boolean;
  accuracy_statement: boolean;
  signature: string;
}

export function useDmca() {
  const [submitting, setSubmitting] = useState(false);

  const submit = useCallback(async (input: DmcaInput) => {
    setSubmitting(true);
    const { error } = await supabase.from("dmca_reports").insert(input as any);
    setSubmitting(false);
    return { error: error?.message ?? null };
  }, []);

  return { submit, submitting };
}
